export default __webpack_public_path__ + "static/media/Illusionist's Staff.102268ef.jpg";